/* KLIK size cue (owner 2026-10-23: "in 3D configurators add subtle outlines or something that lets customers understand
   what sizes they are editing"). While a size field is in use in a studio, a small top-view outline sits on the 3D stage
   with the edited side in bronze and its value: corner sofas by their letters (A main run, B / C side runs, D depth: the
   same letters as the fields), and W / D / H on furniture. Read-only: it never changes the studio, the engine or a price.
   One language per page (html[lang]). */
(() => {
  "use strict";
  if (window.KlikSizeCue) return;
  const AR = () => /^ar/i.test(document.documentElement.lang || "");
  const T = (en, ar) => (AR() ? ar : en);
  const STUDIO = "dialog[open], .kw-workspace, .kz-on, .hz-studio, .kf-studio, [data-klik-dpo-wizard]";
  const NAVY = "#2e4654", BRONZE = "#946d4a", SOFT = "rgba(46,70,84,.16)";
  let box = null, hideTimer = 0, lastKey = "";

  const css = () => {
    if (document.getElementById("klik-size-cue-css")) return;
    const s = document.createElement("style");
    s.id = "klik-size-cue-css";
    s.textContent =
      ".ksc{position:absolute;inset-inline-start:10px;bottom:10px;z-index:6;display:flex;align-items:center;gap:8px;padding:5px 10px 5px 6px;" +
      "border:1px solid rgba(46,70,84,.14);border-radius:10px;background:rgba(255,255,255,.82);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);box-shadow:0 4px 12px rgba(30,45,55,.1);" +
      "color:" + NAVY + ";font:600 13px/1.25 inherit;pointer-events:none;opacity:0;transform:translateY(6px);transition:opacity .18s ease,transform .18s ease}" +
      ".ksc.is-on{opacity:1;transform:none}.ksc svg{flex:none;width:52px;height:37px}.ksc b{display:block;font-size:13.5px;font-weight:700}" +
      ".ksc small{display:block;font-weight:500;font-size:11.5px;opacity:.8}@media (prefers-reduced-motion:reduce){.ksc{transition:none}}";
    document.head.append(s);
  };

  // the field's own label: "A · Main run", «A · الضلع الرئيسي», "Width", «العرض» …
  function labelOf(inp) {
    const own = inp.getAttribute("aria-label");
    if (own) return own;
    if (inp.id) { const l = document.querySelector('label[for="' + CSS.escape(inp.id) + '"]'); if (l) return l.textContent; }
    let n = inp;
    for (let k = 0; k < 3 && n; k++) {
      n = n.parentElement;
      if (!n) break;
      const txt = [...n.childNodes].filter((c) => c !== inp && !(c.contains && c.contains(inp))).map((c) => c.textContent || "").join(" ").replace(/\s+/g, " ").trim();
      if (txt) return txt;
    }
    return "";
  }
  function keyOf(label) {
    const t = String(label || "").trim();
    const m = t.match(/^([A-D])\s*[·•.:\-–]\s*(.*)$/);
    if (m) { const nm = m[2].replace(/\s*(from|up to|من|حتى)\s*[\d٠-٩].*$/i, "").trim(); return { kind: "run", key: m[1], name: nm.charAt(0).toUpperCase() + nm.slice(1) }; }
    if (/\b(width|length)\b|العرض|الطول/i.test(t)) return { kind: "box", key: "W", name: t };
    if (/\bdepth\b|العمق/i.test(t)) return { kind: "box", key: "D", name: t };
    if (/\bheight\b|الارتفاع/i.test(t)) return { kind: "box", key: "H", name: t };
    return null;
  }
  // the shape from the other lettered fields of the same step: C → U, a chaise run → chaise, else L; side from B's name
  function shapeOf(scope) {
    const labels = [...scope.querySelectorAll("input")].filter((i) => i.getBoundingClientRect().width > 0).map((i) => keyOf(labelOf(i))).filter((k) => k && k.kind === "run");
    const has = (k) => labels.some((x) => x.key === k);
    const b = labels.find((x) => x.key === "B");
    const chaise = /chaise|lounger|شيز|استرخاء|ممد/i.test(b ? b.name : "");
    const left = /left|يسار|اليسار/i.test(b ? b.name : "");
    return { u: has("C"), chaise, left };
  }
  function svgRun(shape, key) {
    const r = (x, y, w, h, on) => `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="3" fill="${on ? BRONZE : SOFT}" stroke="${on ? BRONZE : NAVY}" stroke-opacity="${on ? 1 : 0.35}"/>`;
    const parts = [];
    const depthOn = key === "D";
    // A: the main run along the back
    parts.push(r(6, 6, 64, 14, key === "A" || depthOn));
    if (shape.u) {
      parts.push(r(56, 6, 14, 42, key === "B"));
      parts.push(r(6, 6, 14, 42, key === "C"));
    } else if (shape.chaise) {
      parts.push(shape.left ? r(6, 6, 24, 40, key === "B") : r(46, 6, 24, 40, key === "B"));
    } else {
      parts.push(shape.left ? r(6, 6, 14, 42, key === "B") : r(56, 6, 14, 42, key === "B"));
    }
    if (depthOn) parts.push(`<path d="M38 2v22M35 5l3-3 3 3M35 21l3 3 3-3" stroke="${NAVY}" stroke-width="1.4" fill="none" stroke-linecap="round"/>`);
    return `<svg viewBox="0 0 76 54" aria-hidden="true">${parts.join("")}</svg>`;
  }
  function svgBox(key) {
    if (key === "H")
      return `<svg viewBox="0 0 76 54" aria-hidden="true"><rect x="12" y="14" width="40" height="30" rx="3" fill="${SOFT}" stroke="${NAVY}" stroke-opacity=".35"/><path d="M62 12v34M59 15l3-3 3 3M59 43l3 3 3-3" stroke="${BRONZE}" stroke-width="2" fill="none" stroke-linecap="round"/></svg>`;
    const across = key === "W";
    return `<svg viewBox="0 0 76 54" aria-hidden="true"><rect x="10" y="10" width="52" height="30" rx="3" fill="${SOFT}" stroke="${NAVY}" stroke-opacity=".35"/>` +
      (across ? `<path d="M10 48h52M13 45l-3 3 3 3M59 45l3 3-3 3" stroke="${BRONZE}" stroke-width="2" fill="none" stroke-linecap="round"/>` : `<path d="M70 10v30M67 13l3-3 3 3M67 37l3 3 3-3" stroke="${BRONZE}" stroke-width="2" fill="none" stroke-linecap="round"/>`) + "</svg>";
  }
  function stageOf(scope) {
    const cv = [...scope.querySelectorAll("canvas")].find((c) => { const q = c.getBoundingClientRect(); return q.width > 150 && q.height > 100; });
    if (!cv) return null;
    let host = cv.parentElement;
    for (let k = 0; k < 4 && host && getComputedStyle(host).position === "static"; k++) host = host.parentElement;
    return host || cv.parentElement;
  }
  function show(inp) {
    const scope = inp.closest(STUDIO);
    if (!scope) return;
    // the 3D stage is a sibling of the step panel: look from the outermost studio root
    const root = inp.closest(".kw-workspace") || inp.closest("dialog[open]") || scope;
    const k = keyOf(labelOf(inp));
    if (!k) return hide(0);
    const stage = stageOf(root) || stageOf(document);
    if (!stage) return;
    css();
    if (!box || !box.isConnected || box.parentElement !== stage) { box?.remove(); box = document.createElement("div"); box.className = "ksc"; box.setAttribute("aria-hidden", "true"); stage.append(box); }
    const v = String(inp.value || "").replace(/[^\d]/g, "");
    const name = k.name && k.kind === "run" ? k.name : k.key === "W" ? T("Width", "العرض") : k.key === "D" ? T("Depth", "العمق") : k.key === "H" ? T("Height", "الارتفاع") : "";
    const head = (k.kind === "run" ? k.key + " · " : "") + (v ? v + " " + T("cm", "سم") : T("Enter a size", "أدخل المقاس"));
    const sig = k.kind + k.key + "|" + head + "|" + name;
    if (sig !== lastKey) {
      lastKey = sig;
      box.innerHTML = (k.kind === "run" ? svgRun(shapeOf(root), k.key) : svgBox(k.key)) + `<span><b>${head}</b><small>${name.replace(/</g, "&lt;")}</small></span>`;
    }
    clearTimeout(hideTimer);
    requestAnimationFrame(() => box && box.classList.add("is-on"));
  }
  function hide(delay) {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => { if (box) box.classList.remove("is-on"); lastKey = ""; }, delay == null ? 2200 : delay);
  }
  const isField = (t) => t && t.tagName === "INPUT" && /^(text|number|tel)?$/i.test(t.type || "") && t.closest && t.closest(STUDIO);
  document.addEventListener("focusin", (e) => { if (isField(e.target)) show(e.target); }, true);
  document.addEventListener("input", (e) => { if (isField(e.target)) show(e.target); }, true);
  document.addEventListener("focusout", (e) => { if (isField(e.target)) hide(); }, true);

  /* Review: ONE "Optional extras" checklist at the top of the Review (owner 2026-10-23: "configurators must show customers
     the optional things so they don't miss them", "Do the corner one"). Each row = the current choice + Change / Add that
     lands on the control that changes it, outlined for a moment.
     Sofa sets (kz): Pillows, Comfort feel, Coffee table, Pouf (legs stay as pictured in that studio: no shopper control).
     Corner sofas (kd / Hazel): Pillows, Comfort feel, Seat cushions, Legs, Coffee table, Pouf; comfort / cushions / legs
     open the review's own "Comfort & details" editor at that part, Pillows its own Pillows edit.
     Plain classes, not dl/dt/dd (the corner review styles those as its two-column summary), and layered CSS. */
  const firstText = (el) => { if (!el) return ""; const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT); let n; while ((n = w.nextNode())) { const t = n.nodeValue.replace(/\s+/g, " ").trim(); if (t) return t; } return ""; };
  const still = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
  const shown = (el) => !!el && !!el.getClientRects().length && !el.closest("[inert]");
  const flash = (el) => { if (!el) return; el.classList.add("kfh-flash"); setTimeout(() => el.classList.remove("kfh-flash"), 1800); };
  const goTo = (el, open) => { if (!el) return; try { if (open) open.open = true; el.scrollIntoView({ block: "center", behavior: still() ? "auto" : "smooth" }); flash(el); } catch {} };
  // corner sofas: the review card's own Edit, then (comfort editor) bring the wanted part into view once it is showing
  const reviewEdit = (cards, key, rx) => {
    const c = cards.querySelector('.hz-review-card[data-review-section="' + key + '"]') || [...cards.querySelectorAll(".hz-review-card")].find((x) => rx.test(firstText(x)));
    return c ? c.querySelector("dt button") || c.querySelector("button") : null;
  };
  const openPart = (btn, part) => {
    if (!btn) return;
    btn.click();
    let n = 0;
    const seek = () => {
      const el = [...document.querySelectorAll('[data-hz-detail-part="' + part + '"]')].find(shown);
      if (!el) { if (++n < 10) setTimeout(seek, 150); return; }
      el.scrollIntoView({ block: "start", behavior: still() ? "auto" : "smooth" });
      // the editor may reset its own scroll right after opening: check once more
      setTimeout(() => { const r = el.getBoundingClientRect(); if (r.top < 0 || r.top > innerHeight * 0.6) el.scrollIntoView({ block: "start" }); }, 500);
    };
    setTimeout(seek, 250);
  };
  const optsCss = () => {
    if (document.getElementById("kfh-css2")) return;
    const st = document.createElement("style");
    st.id = "kfh-css2";
    st.textContent = "@layer klik-script-safety{" +
      ".kfh-opts{display:block!important;margin:0 0 16px!important;padding:14px 16px 6px!important;border:1px solid " + SOFT + "!important;border-radius:14px!important;background:#fff!important;color:" + NAVY + "!important;box-shadow:none!important;grid-column:1/-1!important}" +
      ".kfh-opts>h3{margin:0 0 2px!important;padding:0!important;border:0!important;font-size:18px!important;line-height:1.25!important;font-weight:600!important;color:inherit!important;text-transform:none!important;letter-spacing:0!important}" +
      ".kfh-opts>p{margin:0 0 6px!important;padding:0!important;font-size:13px!important;line-height:1.4!important;color:inherit!important;opacity:.75}" +
      ".kfh-list{display:block!important;list-style:none!important;margin:0!important;padding:0!important}" +
      ".kfh-row{display:grid!important;grid-template-columns:minmax(76px,30%) minmax(0,1fr) auto!important;align-items:center!important;gap:10px!important;margin:0!important;padding:4px 0!important;border:0!important;border-top:1px solid rgba(46,70,84,.1)!important;background:none!important;list-style:none!important}" +
      ".kfh-row:first-child{border-top:0!important}" +
      ".kfh-k{display:block!important;margin:0!important;font-size:13.5px!important;line-height:1.3!important;font-weight:400!important;opacity:.78}" +
      ".kfh-v{display:block!important;margin:0!important;min-width:0!important;font-size:14px!important;line-height:1.3!important;font-weight:600!important;overflow-wrap:anywhere!important}" +
      ".kfh-go{appearance:none!important;display:inline-flex!important;align-items:center!important;justify-content:flex-end!important;justify-self:end!important;box-sizing:border-box!important;width:auto!important;height:auto!important;min-width:44px!important;min-height:40px!important;margin:0!important;padding:0 2px!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;color:inherit!important;font:inherit!important;font-size:14px!important;font-weight:600!important;letter-spacing:0!important;text-transform:none!important;text-decoration:underline!important;text-decoration-color:" + BRONZE + "!important;text-underline-offset:3px!important;white-space:nowrap!important;cursor:pointer!important}" +
      ".kfh-go:focus-visible{outline:2px solid " + BRONZE + "!important;outline-offset:2px!important}" +
      ".kfh-flash{outline:2px solid " + BRONZE + "!important;outline-offset:4px!important;border-radius:12px;transition:outline-color .6s}" +
      "}";
    document.head.append(st);
  };
  function comfortLine() {
    const ws = document.querySelector("[data-klik-dpo-wizard].kz-on") || document.querySelector(".kw-workspace");
    if (!ws) return;
    const kzCard = ws.querySelector(".kz-card.kz-order");
    const kdCards = ws.querySelector(".klik-dpo-review dl.hz-review-cards");
    const kz = !!kzCard && !!kzCard.getClientRects().length;
    const card = kz ? kzCard : kdCards && kdCards.getClientRects().length ? kdCards : null;
    if (!card) return;
    const det = ws.querySelector("details.hz-deep-options");
    const groups = det ? [...det.querySelectorAll("section, .klik-choice-field")].filter((g) => g.querySelector("input")) : [];
    const pick = (rx) => {
      const g = groups.find((x) => rx.test(firstText(x)) && x.querySelector("input:checked")) || groups.find((x) => rx.test(firstText(x)));
      if (!g) return null;
      const on = g.querySelector("input:checked");
      return { el: g, value: on ? firstText((on.closest(".field") || on.parentElement).querySelector("label") || on.parentElement) : "" };
    };
    const asPictured = T("As pictured", "كما في الصورة"), change = T("Change", "تغيير"), add = T("Add", "أضف"), none = T("None yet", "لم تُضف بعد");
    const rows = [];
    const comfort = pick(/^(how firm|comfort|إحساس|ما مدى)/i) || pick(/comfort|firm|راحة/i);
    if (kz) {
      // pillows: the Fabric step's own summary line ("Pillows: As pictured"); Change = the set card's own pillows link
      const jump = ws.querySelector(".kff-parts-jump span");
      const pillowsPart = jump ? jump.textContent.split(" · ").find((x) => /^(Pillows|المخدات)\s*:/.test(x.trim())) : "";
      const pillowsLink = [...card.querySelectorAll("a, button")].find((x) => /pillow|المخدات/i.test(x.textContent));
      if (pillowsLink) rows.push({ key: "pillows", label: T("Pillows", "المخدات"), value: pillowsPart ? pillowsPart.split(":").slice(1).join(":").trim() : asPictured, act: change, run: () => pillowsLink.click() });
      // comfort: the Review's own chips further down (the deep options are parked in this studio)
      const seat = [...ws.querySelectorAll(".kz-addon")].find((x) => shown(x) && /^(Comfort feel|Seat feel|إحساس الراحة|راحة الجلسة)/.test(firstText(x)));
      if (seat) {
        const on = seat.querySelector('[aria-pressed="true"]');
        rows.push({ key: "comfort", label: T("Comfort feel", "إحساس الراحة"), value: (on && on.textContent.trim()) || (comfort && comfort.value) || asPictured, act: change, run: () => goTo(seat) });
      }
    } else {
      const pil = reviewEdit(card, "pillows", /^(pillows|المخدات)/i);
      const pilCard = pil && pil.closest(".hz-review-card");
      if (pilCard) {
        const line = firstText(pilCard.querySelector("dd"));
        const empty = !line || /no accent pillows|لم يتم اختيار مخدات/i.test(line);
        rows.push({ key: "pillows", label: T("Pillows", "المخدات"), value: empty ? none : line, act: empty ? add : change, run: () => pil.click() });
      }
      const ce = reviewEdit(card, "comfort", /^(comfort|الراحة)/i);
      const via = (part, g) => () => (ce ? openPart(ce, part) : goTo(g && g.el, det));
      if (comfort) rows.push({ key: "comfort", label: T("Comfort feel", "إحساس الراحة"), value: comfort.value || asPictured, act: change, run: via("feel", comfort) });
      const cushions = pick(/^(how should the seat cushions|seat cushion|كيف تبدو وسائد|كيف تحب مخدات المقعد|شكل وسائد)/i);
      if (cushions && cushions.value) rows.push({ key: "cushions", label: T("Seat cushions", "وسائد المقعد"), value: cushions.value, act: change, run: via("cushions", cushions) });
      const legs = pick(/^(leg style|شكل الأرجل|الأرجل)/i) || pick(/leg|base|أرجل|قاعدة/i);
      const legFinish = pick(/^(leg finish|لون الأرجل|تشطيب الأرجل)/i);
      // fixed-base models (the sectional batch marks the leg field "batch-fixed-frame"): legs stay as pictured, no choice
      if (legs && !ws.querySelector(".batch-fixed-frame")) rows.push({ key: "legs", label: T("Legs", "الأرجل"), value: [legs.value || asPictured, legFinish && legFinish.value && legFinish.value !== legs.value ? legFinish.value : ""].filter(Boolean).join(" · "), act: change, run: via("legs", legs) });
    }
    const rail = ws.querySelector(".kse-rail");
    if (rail) {
      const added = [...ws.querySelectorAll(".kse-card")].filter((c) => c.querySelector('.kse-add[aria-pressed="true"]')).map((c) => firstText(c.querySelector(".kse-name")));
      rows.push({ key: "table", label: T("Coffee table", "طاولة القهوة"), value: added.length ? added.join(", ") : none, act: added.length ? change : add, run: () => goTo(rail.closest(".kse") || rail) });
    }
    const pouf = ws.querySelector(".kse-pouf");
    if (pouf) {
      const on = pouf.querySelector('.kse-chip[aria-pressed="true"]');
      const name = on ? firstText(on.querySelector(".kse-chip-name") || on) : "";
      const no = !on || /^(no pouf|بدون)/i.test(name);
      rows.push({ key: "pouf", label: T("Pouf", "البوف"), value: no ? none : name, act: no ? add : change, run: () => goTo(pouf) });
    } else if (!kz) {
      const pe = reviewEdit(card, "pouf", /^(matching pouf|البوف)/i);
      const pc = pe && pe.closest(".hz-review-card");
      if (pc) { const line = firstText(pc.querySelector("dd")); const no = !line || /^(no pouf|بدون بوف)/i.test(line); rows.push({ key: "pouf", label: T("Pouf", "البوف"), value: no ? none : line, act: no ? add : change, run: () => pe.click() }); }
    }
    if (!rows.length) return;
    card.querySelectorAll(".kfh-comfort").forEach((x) => x.remove());
    optsCss();
    let box = ws.querySelector(".kfh-opts");
    if (!box || !box.isConnected) {
      box = document.createElement("section");
      box.className = "kfh-opts";
      box.setAttribute("aria-label", T("Optional extras", "إضافات اختيارية"));
    }
    // sets: above the set card; corners: top of the Review, above the price card
    const rev = kz ? null : card.closest(".klik-dpo-review");
    const lead = () => rev && (rev.querySelector(":scope > .kw-assure") || rev.querySelector(":scope > .kw6-decide"));
    const before = kz ? card : lead() || card;
    if (box.nextElementSibling !== before) before.parentElement.insertBefore(box, before);
    // program-1027 wave1-fix SP05B-AR-CHECKLIST: keep the checklist through a Review rebuild that no click caused (the
    // sofa-set Review rebuilds its whole view when a background cart-line warm-up re-captures pieces restored from the
    // pictured-set bank). Pass 1 runs in the observer's microtask, before the next paint, so the box never drops out;
    // pass 2 runs after the next frames, once klik-pdp.js has re-added the card's pillows link the Pillows row uses.
    const host = box.parentElement;
    if (kz && host && !host.kfhHeal) {
      let late = 0;
      host.kfhHeal = new MutationObserver(() => {
        if (!host.isConnected || host.querySelector(":scope > .kfh-opts")) return;
        const c = host.querySelector(":scope > .kz-card.kz-order");
        if (!c || !c.getClientRects().length) return;
        comfortLine();
        cancelAnimationFrame(late);
        late = requestAnimationFrame(() => (late = requestAnimationFrame(() => setTimeout(comfortLine, 0))));
      });
      host.kfhHeal.observe(host, { childList: true });
    }
    if (rev && !rev.kfhKeep) {
      rev.kfhKeep = new MutationObserver(() => {
        const b = rev.querySelector(":scope > .kfh-opts"), d = lead();
        if (b && d && b.compareDocumentPosition(d) & Node.DOCUMENT_POSITION_PRECEDING) rev.insertBefore(b, d);
      });
      rev.kfhKeep.observe(rev, { childList: true });
    }
    const sig = rows.map((r) => r.key + "=" + r.value + "/" + r.act).join("|");
    if (box.dataset.sig === sig) return;
    box.dataset.sig = sig;
    const h = document.createElement("h3");
    h.textContent = T("Optional extras", "إضافات اختيارية");
    const sub = document.createElement("p");
    sub.textContent = T("Check these before you add to cart.", "راجعها قبل الإضافة إلى السلة.");
    const ul = document.createElement("ul");
    ul.className = "kfh-list";
    for (const r of rows) {
      const li = document.createElement("li"); li.className = "kfh-row";
      const k = document.createElement("span"); k.className = "kfh-k"; k.textContent = r.label;
      const v = document.createElement("span"); v.className = "kfh-v"; v.textContent = r.value;
      const go = document.createElement("button"); go.type = "button"; go.className = "kfh-go"; go.textContent = r.act; go.setAttribute("aria-label", r.act + " · " + r.label); go.addEventListener("click", r.run);
      li.append(k, v, go);
      ul.append(li);
    }
    box.replaceChildren(h, sub, ul);
  }
  document.addEventListener("click", () => setTimeout(comfortLine, 450), true);
  document.addEventListener("change", (e) => { if (e.target && e.target.closest && e.target.closest("details.hz-deep-options")) setTimeout(comfortLine, 60); }, true);
  // program-1027 wave1-fix: refresh() re-runs the Review checklist (sofa-catalog-set-cart.js calls it after its cart-line warm-up)
  window.KlikSizeCue = Object.freeze({ version: "2026-10-27-fix", show, hide, refresh: () => { try { comfortLine(); } catch (e) {} } });
})();
